//高鐵選票區
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// TS type
import { RootState } from '@redux/store';
// component
import Counter from '@Common/counter';

interface ITicketBlockProps {
    seatInfo: any;
    whenChange?: (data: any) => void;
}

const TicketBlock: React.FC<ITicketBlockProps> = (props) => {
    const dispatch = useDispatch();
    const store_THSR = useSelector((state: RootState) => state.THSR);
    const ticketsData = store_THSR.THSRInitData.TrainTickets;
    //[2,0,0,0]
    const [ticketNum, setTicketNum] = React.useState<any>(
        Object.keys(props.seatInfo).map((key) => props.seatInfo[key])
    );
    //{F:0,H:0,E:0,W:0}
    const [ticketNumInfo, setTicketNumInfo] = React.useState<any>();

    const ticketChange = (num, index) => {
        let ticketV = ticketsData[index].TicketId;

        setTicketNumInfo((prevState) => ({ ...prevState, [ticketV]: num }));
        let newTicketNum = ticketNum;
        newTicketNum[index] = num;
        setTicketNum([...newTicketNum]);
    };

    React.useEffect(() => {
        props.whenChange && props.whenChange(ticketNumInfo);
    }, [props, ticketNumInfo]);

    return (
        <div className="ticketsBlock">
            {ticketsData.map((child, index) => {
                return (
                    <div className="ticket">
                        <span className="ticketTitle">{child.TicketName}</span>
                        <div className="ticketCounter">
                            {/*成人[F] 、敬老[E]、愛心[W]、孩童[H]票*/}
                            <Counter
                                // ticketSeq={index}
                                maxNum={
                                    child.HighQty < store_THSR.THSRInitData.TicketRule.TotalMaxQty
                                        ? child.HighQty
                                        : store_THSR.THSRInitData.TicketRule.TotalMaxQty -
                                          ticketNum
                                              .filter((child, i) => i !== index)
                                              .reduce((a, b) => a + b, 0)
                                }
                                lowQty={child.LowQty}
                                onChange={(num) => {
                                    ticketChange(num, index);
                                }}
                                defaultValue={ticketNum[index]}
                                disableAdd={
                                    ticketNum[index] >= child.HighQty ||
                                    ticketNum.reduce((a, b) => a + b, 0) >=
                                        store_THSR.THSRInitData.TicketRule.TotalMaxQty
                                }
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TicketBlock;
